<template>
  <footer class="footer skinc-container">
    <div class="footer-top">
      <div class="footer-gnb-wrapper">
        <FooterGnb />
      </div>
      <FooterRight />
    </div>
    <FooterBottom />
  </footer>
</template>

<script>
import FooterGnb from './FooterGnb.vue';
import FooterRight from './FooterRight.vue';
import FooterBottom from './FooterBottom.vue';

export default {
  name: 'Footer',
  components: {
    FooterGnb,
    FooterRight,
    FooterBottom
  }
};
</script>

<style scoped>
.footer {
  min-height: 60vh;
  width: 100%;
  background-color: #f6f2f2;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
}

.footer-top {
  display: flex;
  justify-content: space-between;
  padding: 10vh 0 0 0;
  align-items: stretch;
}

@media (max-width: 1200px) {
  .footer-top {
    flex-direction: column;
    gap: 60px;
  }
}

@media (max-width: 768px) {
  .footer-gnb-wrapper {
    display: none;
  }
}
</style>
